import axios from 'axios';

import {FrontConfig} from '../bundlerDefinedConfig';
import {SurveyRouterData} from '../components/survey/surveyRoutesHelpers';

export function postSurvey(routerData: SurveyRouterData, score: number, note?: string, contact?: string) {
  const prefix = `api/1/noauth/companies/${routerData.slug}/srvy/v2`;

  return axios({
    method: 'post',
    url: `${FrontConfig.MAIN_APP_URL}/${prefix}/response`,
    data: {
      msg_uid: routerData.msgUid,
      company_slug: routerData.slug,
      score,
      note,
      contact_handle: contact,
    },
  });
}

export async function fetchConfig({queryKey}: {queryKey: [string, string | undefined]}) {
  const [_, companySlug] = queryKey;
  const {data} = await axios({
    method: 'get',
    url: `${FrontConfig.MAIN_APP_URL}/api/1/noauth/companies/${companySlug}/srvy/settings`,
  });
  return data;
}
